import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Row, Col } from "antd";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { CustomInputWithController } from "../../Core/Components/CustomInput";
import Button from "../../Core/Components/CustomButton";
import SetPasswordResetScreen from "./SetPasswordResetScreen";
import ResetPasswordSuccessScreen from "./ResetPasswordSuccessScreen";
import { updateLoggedInUser } from "../../Redux/Slices/loggedInUser.slice";

const validationForEmail = {
  required: "please enter email address",
  pattern: {
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/,
    message: "Enter a vaild email",
  },
};

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const { handleSubmit, control, formState, setError } = useForm({
    email: "",
  });

  const [enteredEmail, setEnteredEmail] = useState("");
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [focus, setFocus] = useState(false);

  const onSubmit = async (e) => {
    const { email } = e;
    setEnteredEmail(email);

    try {
      dispatch(
        updateLoggedInUser({
          key: "loading",
          value: true,
        }),
      );

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
        {
          email,
        },
      );

      if (response.status === 200) {
        setShowSuccessPopUp(true);
      }
    } catch (error) {
      setError(error.response.data.type, {
        type: "server",
        message: error.response.data.message,
      });
    } finally {
      dispatch(
        updateLoggedInUser({
          key: "loading",
          value: false,
        }),
      );
    }
  };

  if (searchParams.has("token")) {
    return <SetPasswordResetScreen />;
  }

  return (
    <div>
      {showSuccessPopUp ? (
        <ResetPasswordSuccessScreen email={enteredEmail} />
      ) : (
        <>
          <div className="hidden lg:block w-screen h-screen">
            <Row className="h-full">
              <Col span={15} className="h-full overflow-hidden">
                <img
                  src="/assets/images/Login/login-image-new.png"
                  alt="LoginImage"
                  className="object-cover w-full h-full"
                />
              </Col>
              <Col span={9}>
                <div className="flex flex-col items-center justify-center w-full h-full gap-y-5 font-poppins bg-background-white">
                  <img
                    src="/assets/songa-main-logo.svg"
                    alt="Songa Mobility"
                    className="w-[258px] h-14"
                  />
                  <div>
                    <div className="text-base font-medium text-center capitalize">
                      reset password
                    </div>
                    <div className="mt-2 w-[242px] text-xs font-light leading-4.5 text-dark-gray text-center">
                      Enter your email and you will receive a link to rest your
                      password
                    </div>
                  </div>
                  <form
                    className="flex flex-col items-center justify-center w-full gap-y-6"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <CustomInputWithController
                      intent="login"
                      control={control}
                      formState={formState}
                      focus={focus}
                      setFocus={setFocus}
                      name="email"
                      placeholder="Enter Email"
                      rules={validationForEmail}
                    />
                    <Button width="login" type="submit" className="capitalize">
                      Send me the link
                    </Button>
                    <button
                      type="button"
                      onClick={() => navigate("/")}
                      className="cursor-pointer font-poppins font-light text-xs leading-4.5 text-dark-grey-text hover:text-new-black hover:underline"
                    >
                      Back to Login
                    </button>
                  </form>
                </div>
              </Col>
            </Row>
          </div>
          <div className="lg:hidden w-screen h-screen flex flex-col items-start justify-start gap-y-5 font-poppins bg-background-white">
            <div className="w-full h-[259px] relative">
              <img
                src="/assets/images/Signup/signup-mobile-new.png"
                alt="Signup Header"
                className="w-full h-full object-cover "
              />
              <div className="absolute inset-0 flex flex-col pb-7 px-6 gap-8 pt-8">
                <img
                  src="/assets/images/Signup/logo.png"
                  alt="Songa Mobility"
                  className="w-10 h-10"
                />
                <div className="mt-2">
                  <p className="text-white text-xl font-semibold">
                    Forgot password?
                  </p>
                  <p className="text-white/80 text-sm mt-1">
                    Enter your email and you will receive a link to reset your
                    password
                  </p>
                </div>
              </div>
            </div>
            <form
              className="flex flex-col items-start justify-center w-full gap-y-4 px-4"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="w-full">
                <p className="font-normal text-sm text-grey-200 leading-none text-left mb-[6px]">
                  Email
                </p>
                <CustomInputWithController
                  intent="mobile"
                  text="mobile"
                  placeholderText="mobile"
                  control={control}
                  formState={formState}
                  focus={focus}
                  setFocus={setFocus}
                  name="email"
                  placeholder="Enter email address"
                  rules={validationForEmail}
                />
              </div>
              <Button width="full" type="submit" className="capitalize">
                Send me the link
              </Button>
            </form>
          </div>
        </>
      )}
    </div>
  );
};
export default ResetPassword;
